<ng-template #modalTpl let-modal>

    <div class="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" class="close" (click)="modal.dismiss()">
            <span>&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="inner-container">
            <div *ngIf="helpText" class="import-help-note d-flex align-items-start">
                <mat-icon class="help-icon flex-shrink-0">info</mat-icon>
                <div class="flex-grow-1">
                    {{ helpText }}
                </div>
            </div>

            <div class="form-group">
                <label>Select CSV File</label>

                <div class="d-flex" style="height: 40px;">
                    <div class="flex-grow-1 border border-right-0 rounded-left px-3
                    d-flex align-items-center bg-light text-muted text-truncate">
                        {{ selectedFile?.name || 'No file chosen' }}
                    </div>

                    <label for="csvFileInput" class="border rounded-right px-4 mb-0 d-flex align-items-center bg-white"
                        style="cursor: pointer;">
                        Choose
                    </label>

                    <input id="csvFileInput" type="file" accept=".csv" hidden (change)="onFileSelected($event)" />
                </div>
            </div>

            <div *ngIf="validationError" class="text-danger mb-3">
                {{ validationError }}
            </div>

            <div class="mb-3">
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="downloadSampleCsv()">
                    Download Sample CSV
                </button>
                <small class="text-muted ml-2">Use this as a template for your import</small>
            </div>

            <div *ngIf="importPreview.length > 0">
                <p class="text-success">{{ importPreview.length }} records ready to import</p>

                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th *ngFor="let col of columns">{{ col.label }}</th>
                            <th *ngIf="invalidRows.length">Errors</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of importPreview" [class.table-danger]="isRowInvalid(row)">
                            <td>{{ rowIndex(row) + 1 }}</td>
                            <td *ngFor="let col of columns">{{ row[col.key] }}</td>
                            <td *ngIf="invalidRows.length">{{ getErrorsForRow(row) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="confirm(modal)" [disabled]="importPreview.length === 0">
            Import
        </button>
    </div>

</ng-template>

<button #openBtn hidden (click)="open()"></button>